export default __webpack_public_path__ + "static/media/yuman1.cc3b2b44.png";